import { AgentInfoCard } from "components/AgentInfoCard";
import { MlsSearchCard } from "components/MlsSearchCard";
import { isProduction } from "scripts/application/setting";
import { useQueryFlags } from "scripts/hooks/useQueryFlags";
import { useUserContext } from "services/UserContext";
import { ISimilarListingsArtifact } from "types/artifacts/search-listings";
import { IArtifactComponentProps } from "types/services";

export interface ISimilarListingOutputParams {
    search_id?: string;
}

export type ISimilarListingOutputProps = IArtifactComponentProps<
    ISimilarListingOutputParams,
    ISimilarListingsArtifact
>;

SimilarListingOutput.artifactKey = "property_detail";
export function SimilarListingOutput(
    props: ISimilarListingOutputProps
): JSX.Element {
    const { user } = useUserContext();
    const { cId } = useQueryFlags();
    const { search_id, artifacts } = props;

    // if there is no valid artifacts return from the backend
    if (!Array.isArray(artifacts)) return <></>;

    if (search_id) {
        const artifact = artifacts.find((x) => x.id === search_id);
        const connectedAgent = user?.connected_agent;
        const isBrandedApp = !!(user.role === "consumer" && connectedAgent);
        const nameOrEmail = `${connectedAgent?.firstname} ${connectedAgent?.lastname}` || connectedAgent?.email || '';

        if (artifact) {
            const modifiedArtifact = {
                id: artifact.id,
                response: {
                    ...artifact.response.similar_listings,
                    properties: artifact.response.similar_listings.properties,
                }
            };
            return (
                <>
                    {(isBrandedApp || cId) && (
                        <div className="bg_color_cement_light border_radius--round12 mb-4 py-md-2 py-0">
                            <div className="row no-gutters justify-content-center align-items-center ">
                                <span className="font_size--large_extra px-3 py-2 col-md-auto col-12 font_size--large_sm font_weight--bold border-bottom border-md-bottom-0">Presented by</span>
                                <div className="col-md col-12 px-3 py-2">
                                    <AgentInfoCard
                                        agentProfileUrl={connectedAgent?.bioUrl}
                                        brokerProfileUrl={connectedAgent?.office_url || ''}
                                        name={nameOrEmail}
                                        photo={connectedAgent?.photo || ""}
                                        officeName={connectedAgent?.office_name || ""}
                                        mlsPlantinum={connectedAgent?.is_platinum}
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                    <MlsSearchCard.Carousel artifact={modifiedArtifact} hideFiltersAndAiSummary />
                </>
            );
        }

        console.error(
            "No artifact found for 'SimilarListingOutput' with the given search_id:",
            search_id
        );

        return <></>;
    }

    console.error("No search_id provided for 'SimilarListingOutput'.");

    return <></>;
}

SimilarListingOutput.asText = function (props: ISimilarListingOutputProps): string {
    // console.log("SimilarListingOutput.asText", props);
    return props?.artifacts && props.artifacts.length > 0 ? props.artifacts[0]?.response?.similar_listings?.artifact_text || "" : isProduction ? "" : "SimilarListingOutput asText Not Implemented!";
}

